import { proxy } from 'core/classes/helpers/UrlHelper'

type TFileLink = {
  entryId?: number
  uid?: string
  fileName: string
  fieldName: string
  formId: number
}

export const getFileLink = ({ uid, entryId, fieldName, fileName, formId }: TFileLink) => {
  const baseUrl = `/form/${formId}`

  if (uid && fileName) {
    return proxy(`${baseUrl}/links/v2/${uid}/${fieldName}/${fileName.replace(/&/g, '_')}`)
  }

  if (entryId && fileName) {
    return proxy(`${baseUrl}/links/${entryId}/${fieldName}/${fileName.replace(/&/g, '_')}`)
  }

  if (fileName) {
    return fileName
  }

  return ''
}
